import httpClient from '@/api/httpClient'
import Constant from '@/constant/index'
import ECAUtil from '@/utils/ecaUtil'
import { POST } from '@/api/api'
import Utils from '@/utils/index'
import distanceUtil from '@/utils/distanceUtil'
import _ from 'lodash'
import numeral from 'numeral'

const state = {
  mapAndLayerLoaded: false,

  isCalculating: false,
  isGettedDistance: false, // 得到数据未绘制
  isGettedDistanceFail: false, //
  isCompleteDistance: false,
  isNeedRefreshDistance: false,
  distanceClearFlag: false, // 所有
  clearOnlyDistancingFlag: false, // 保留港口
  baseMapSelected: 0,

  useEca: true,
  speed: 12,
  portPointArr: [],
  preservedPortPointArr: [],

  routePoints: [], // 航线数据
  originRoutes: [], // 原始航线
  preservedOriginRoutes: [], // 原始航线副本

  routePaths: [], // 未经过ECA区域的航线路径
  routeWithECA: [], // 经过ECA区域的航线路径

  routePorts: [], // 港口间航程数据
  ttlDistance: 0, // 总航程
  ttlEcaDistance: 0, // 经过ECA区域的航程
  ttlSeaTime: 0, // 总的航行时间
  preservedTtlDistance: 0, // 总航程副本

  trackVisible: false,
  ecaAreas: [], // eca区域的数组
  ecaLines: [], // eca边线的数组

  mapCurrentPoint: null,

  turningPoints: [], // 转向点数组
  turnLayerVisible: false,
  resetTurnLayerFlag: false,

  isRoute: false,
  isRouteDis: false,

  advVisible: false
}

// getters
const getters = {

}

// actions
const actions = {
  async getDistance ({ commit, rootState, dispatch }, payload = {}) {
    const arr = []
    state.portPointArr.forEach((ele) => {
      arr.push(ele.PortID)
    })
    const res = await POST('/CalcDis4Mobile', {
      OperID: Utils.getWithExpiry('operID'),
      PortStr: arr.join(','),
      ExcRoutePoint: rootState.route.excWayPointArr.join(',')
    })

    // Your day limit is over.You can try again tomorrow ---310001
    var routes = res.routePoints
    if (!routes ) {
      commit('setIsGettedDistance', false)
      commit('setIsCalculating', false)
      commit('setIsGettedDistanceFail', true)
      return
    }

    commit('storeRoutes', routes)
    dispatch('reBuildRoutes')
  },

  async reBuildRoutes ({ rootState, commit }) {
    if (state.originRoutes && state.originRoutes.length > 0) {
      let routes = distanceUtil.reBuildLinePoint(state.originRoutes) // 是否要clone?

      routes = await ECAUtil.buildRoutePointsWithECA(state.ecaAreas, routes)

      //检查是否经过舟山区域
      let pass = false
      for (let k=0; k<routes.length; k++) {
        let rlst = routes[k]
        for (let i=0 ; i<rlst.route.length; i++) {
          if (rlst.route[i].lat>29.445 && rlst.route[i].lat<31.047 && 
            rlst.route[i].lon>121.623 && rlst.route[i].lon<123.617 ) {
              pass =  true
              break;
            }
        }
        if (pass) break
      }

      if (pass) 
        commit('setAdvVisible', true)
      else 
        commit('setAdvVisible', false)
      

      commit('setRoutePoints', routes) // 更新航线数据
      commit('setTurningPoint', _.cloneDeep(routes)) // ??

      commit('buildDistanceResult') // 生成航程计算的结果
      commit('createTrackPath2') // 创建航线轨迹数据
      // dispatch("buildPortResult") //
      // 关闭路由
      commit('setIsGettedDistance', true)
      commit('setIsGettedDistanceFail', false)
      // return route
    } else {
      commit('setIsGettedDistance', false)
      commit('setIsCalculating', false)
      commit('setIsGettedDistanceFail', true)
    }
  }

} // end actions

// mutations
const mutations = {
  setMapAndLayerLoaded (state, payload) {
    state.mapAndLayerLoaded = payload
  },
  setIsGettedDistance (state, payload) {
    state.isGettedDistance = payload
  },
  setIsGettedDistanceFail (state, payload) {
    state.isGettedDistanceFail = payload
  },
  setIsCalculating (state, payload) {
    state.isCalculating = payload
  },
  setIsCompleteDistance (state, payload) {
    state.isCompleteDistance = payload
  },
  setBaseMapSelected (state, payload) {
    state.baseMapSelected = payload
  },

  setIsNeedRefreshDistance (state, payload) {
    state.isNeedRefreshDistance = payload
  },
  setDistanceClearFlag (state, payload) {
    state.distanceClearFlag = payload
  },
  setDistanceSpeed (state, payload) {
    state.speed = payload
  },
  setClearOnlyDistancingFlag (state, payload) {
    state.clearOnlyDistancingFlag = payload
  },

  setPortPointArr (state, payload) { // 算是一次性提交
    // state.portPointArr = _.cloneDeep(payload)
    state.portPointArr = payload
  },
  addToPortPointArr (state, payload) {
    state.portPointArr.push(payload)
  },
  removePortPointByIndex (state, payload) {
    state.portPointArr.splice(payload, 1)
  },

  restorePortPointArr (state, payload) {
    state.portPointArr = state.portPointArr.filter(ele => !ele.isWayPoint)
  },

  setPreservedPortPointArr (state, payload) {
    state.preservedPortPointArr = payload
  },

  addRequiredWayPointToPortPointArr (state, payload) {
    state.portPointArr.splice(payload.index, 0, payload)
  },
  removeRequiredWayPointFromPortPointArr (state, payload) {
    var index = state.portPointArr
      .findIndex(ele => ele.PortID === payload.PortID)
    if (index !== -1) {
      state.portPointArr.splice(index, 1)
    }
  },

  clearDistancingResult (state, payload) {
    state.isCalculating = false
    state.isGettedDistance = false
    state.isCompleteDistance = false

    state.routePoints = []
    state.routePorts = []
    state.ttlDistance = 0
    state.ttlEcaDistance = 0
    state.ttlSeaTime = 0

    state.routePaths = []
    state.routeWithECA = []

    state.preservedPortPointArr = []
  },

  clearAllDistance (state, payload) {
    state.portPointArr = []
    state.preservedPortPointArr = []

    state.isCalculating = false
    state.isGettedDistance = false
    state.isCompleteDistance = false

    state.routePoints = []
    state.routePorts = []
    state.ttlDistance = 0
    state.ttlEcaDistance = 0
    state.ttlSeaTime = 0

    state.routePaths = []
    state.routeWithECA = []

    state.resetTurnLayerFlag = false
  },

  setTtlSeaTime (state, payload) {
    state.ttlSeaTime = payload
  },

  // 设置eca区域数据
  setEcaAreas (state, payload) {
    state.ecaAreas = payload
  },
  // 设置eca区域边线数据
  setEcaLines (state, payload) {
    state.ecaLines = payload
  },
  // 控制是否显示航线
  showTrack (state, payload) {
    state.trackVisible = payload
  },

  // 存储原始航线数据
  storeRoutes (state, payload) {
    let index = 0
    for (let i = 0; i < payload.length; i++) {
      payload[i].distance && delete payload[i].distance
      for (let j = 0; j < payload[i].route.length; j++) {
        const ele = payload[i].route[j]
        ele.routeSeq = index
        index++
      }
    }
    state.originRoutes = payload
    state.preservedOriginRoutes = _.cloneDeep(payload)
  },
  // 存储原始航线数据 2
  setStoreRoutes (state, payload) {
    state.originRoutes = _.cloneDeep(payload)
  },
  // 设置航线的点的数据
  setRoutePoints (state, payload) {
    state.routePoints = payload
  },
  setResetTurnLayerFlag (state, payload) {
    state.resetTurnLayerFlag = payload
  },

  changeIsRouteDis (state, payload) {
    state.isRouteDis = payload
  },
  changeRouteFlag (state, payload) {
    state.isRoute = payload
  },
  // 设置转向点数据
  setTurningPoint (state, payload) {
    let points = []
    payload.forEach(item => {
      points = points.concat(item.route)
    })
    points = points.filter(item => {
      return item.hasOwnProperty('routeSeq') && item.wn !== 'eca'
    })
    state.turningPoints = points
  },
  // 修改转向点
  updateRouteFromRaw (state, payload) {
    for (let i = 0; i < state.originRoutes.length; i++) {
      const item = state.originRoutes[i]
      const temp = item.route.find(ele => {
        return ele.routeSeq == payload.id
      })
      if (temp) {
        temp.lon = payload.longitude
        temp.lat = payload.latitude
        break
      }
    }
  },

  // 添加转向点
  addRouteFromRaw (state, payload) {
    let sum = 0
    for (let i = 0; i < state.originRoutes.length; i++) {
      sum += state.originRoutes[i].route.length
    }
    for (let i = 0; i < state.originRoutes.length; i++) {
      const item = state.originRoutes[i]
      const ind = item.route.findIndex(ele => {
        return ele.routeSeq == payload.id
      })
      if (ind !== -1) {
        const obj = {
          gVal: numeral(distanceUtil.greatCircleDist(
            item.route[ind].lon, item.route[ind].lat,
            payload.lon,
            payload.lat
          )).format('0,0.00'),
          routeSeq: sum,
          lon: payload.lon,
          lat: payload.lat,
          wt: '1'
        }
        item.route.splice(ind + 1, 0, obj)
        break
      }
    }
  },
  // 删除转向点
  delRouteFromRaw (state, payload) {
    for (let i = 0; i < state.originRoutes.length; i++) {
      const item = state.originRoutes[i]
      const ind = item.route.findIndex(item => {
        return item.routeSeq == payload.id
      })
      if (ind !== -1) {
        item.route.splice(ind, 1)
        break
      }
    }
  },

  // 创建航程计算结果
  buildDistanceResult (state) {
    // console.log(state.routePoints);
    var routes = state.routePoints
    var ttlDistance = 0; var ttlEcaDistance = 0
    var distance = 0; var ecaDistance = 0
    var ttlSeaTime = 0
    var routePorts = [] // 存放港口和港口间距离

    for (var i = 0; i < routes.length; i++) {
      var route = routes[i].route
      ttlDistance += routes[i].distance
      distance += routes[i].distance
      if (routes[i].eca) {
        ecaDistance += routes[i].distance
        ttlEcaDistance += routes[i].distance
      }

      for (var j = 0; j < route.length; j++) {
        // 加入港口间距离
        if (j == 0 && i == 0) {
          var startPortObj = _.cloneDeep(route[j])
          startPortObj.gVal = 0
          startPortObj.ecaVal = 0
          startPortObj.time = 0
          routePorts.push(startPortObj)
        } else if (j == route.length - 1) {
          if (route[j].wn == 'eca') continue

          var toPortObj = _.cloneDeep(route[j])
          toPortObj.gVal = distance
          toPortObj.ecaVal = ecaDistance
          toPortObj.time = _.round(toPortObj.gVal / (state.speed * 24), 2)
          ttlSeaTime += toPortObj.time

          routePorts.push(toPortObj)
          distance = ecaDistance = 0
        }
      }
    }

    state.routePoints = routes
    state.routePorts = routePorts
    state.ttlSeaTime = _.round(ttlSeaTime, 2)
    state.ttlEcaDistance = _.round(ttlEcaDistance, 2)
    state.ttlDistance = _.round(ttlDistance, 2)
    state.preservedTtlDistance = state.ttlDistance
  },

  // 生成绘制航线的连线的数据
  createTrackPath (state) {
    state.routePaths = []
    state.routeWithECA = []
    for (let i = 0; i < state.routePoints.length; i++) {
      const obj = state.routePoints[i]
      var arr = []
      var deltaDegree = 0
      var crosses180Direction = 0
      var route = _.cloneDeep(obj.route)
      for (let j = 0; j < route.length; j++) {
        if (j > 0) {
          // 同一位置的，跳过
          if (
            route[j - 1].lon == route[j].lon &&
              route[j - 1].lat == route[j].lat &&
              route[j - 1].wt != '0' &&
              route[j].wt != '0'
          ) { continue }
          crosses180Direction = distanceUtil.judgeCrosses180Degrees(
            route[j - 1],
            route[j]
          )
          if (crosses180Direction == 1) { deltaDegree += 360 } // 由东向西
          else if (crosses180Direction == -1) { deltaDegree -= 360 } // 由西向东

          var lon = route[j].lon + deltaDegree
          arr.push([lon, route[j].lat])
        } else { arr.push([route[j].lon, route[j].lat]) }
      }
      if (obj.eca) {
        state.routeWithECA.push(arr)
      } else {
        state.routePaths.push(arr)
      }
    }
  }, // end createTrackPath

  createTrackPath2 (state) {
    state.routePaths = []
    state.routeWithECA = []
    let tempArr = []
    for (let i = 0; i < state.routePoints.length; i++) {
      const obj = state.routePoints[i]
      var arr = []
      let ids = []
      var deltaDegree = 0
      var crosses180Direction = 0
      var route = _.cloneDeep(obj.route)
      for (let j = 0; j < route.length; j++) {
        if (j > 0) {
          // 同一位置的，跳过
          if (
            route[j - 1].lon == route[j].lon &&
              route[j - 1].lat == route[j].lat &&
              route[j - 1].wt != '0' &&
              route[j].wt != '0'
          ) { continue }
          crosses180Direction = distanceUtil.judgeCrosses180Degrees(
            route[j - 1],
            route[j]
          )
          if (crosses180Direction == 1)
          // 由东向西
          { deltaDegree += 360 } else if (crosses180Direction == -1)
          // 由西向东
          { deltaDegree -= 360 }

          const lon = route[j].lon + deltaDegree
          if (route[j].wt == '11' || route[j].wt == '19' || route[j].wn == 'eca') {
            arr.push([lon, route[j].lat])
          }
          if (arr.length && route[j].wt != '11' && route[j].wt != '19') {
            arr.push([lon, route[j].lat])
            route[j].wn !== 'eca' ? ids.push(route[j].routeSeq) : ids.push(route[j].wn)
            if (ids[0] !== 'eca' && ids[1] == 'eca') {
              const no = state.turningPoints.findIndex(item => {
                return item.routeSeq == ids[0]
              })
              ids = [state.turningPoints[no].routeSeq, state.turningPoints[no + 1].routeSeq]
              tempArr = ids
            }
            if ((ids[0] == 'eca' && ids[1] !== 'eca') || (ids[0] == 'eca' && ids[1] == 'eca')) {
              ids = tempArr
            }
            const temp = {
              distance:
                numeral(distanceUtil.greatCircleDist(
                  arr[0][0], arr[0][1],
                  arr[arr.length - 1][0],
                  arr[arr.length - 1][1])
                ).format('0,0.00'),
              route: arr,
              idArr: ids
            }
            if (obj.eca) {
              state.routeWithECA.push(temp)
            } else {
              state.routePaths.push(temp)
            }
            arr = []
            ids = []
            arr.push([lon, route[j].lat])
            route[j].wn !== 'eca' ? ids.push(route[j].routeSeq) : ids.push(route[j].wn)
          }
        } else {
          arr.push([route[j].lon, route[j].lat])
          route[j].wn !== 'eca' ? ids.push(route[j].routeSeq) : ids.push(route[j].wn)
        }
      }
    }
  }, // end createTrackPath2

  setMapCurrentPoint (state, payload) {
    let lon, lat, lon_M, lat_M, longitude, latitude
    if (!payload || !payload.longitude) {
      return
    }
    lon = parseInt(Math.abs(payload.longitude))
    lat = parseInt(Math.abs(payload.latitude))
    lon_M = (parseFloat(Math.abs(payload.longitude) - lon) * 60).toFixed(5)
    lat_M = (parseFloat(Math.abs(payload.latitude) - lat) * 60).toFixed(5)
    longitude = payload.longitude < 0 ? lon + '°' + lon_M + '′' + 'W' : lon + '°' + lon_M + '′' + 'E'
    latitude = payload.latitude < 0 ? lat + '°' + lat_M + '′' + 'S' : lat + '°' + lat_M + '′' + 'N'
    state.mapCurrentPoint = { lon: longitude, lat: latitude }
  },

  changeTurnLayerVisible (state, payload) {
    state.turnLayerVisible = payload
  },

  setAdvVisible (state, payload) {
    state.advVisible = payload
  }


}

export default {
  state,
  getters,
  mutations,
  actions
}
